import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { HEADER_SPACING_PRESETS } from '@insurancemenu/imenu-components-lib';
import { useQuoteAddEmployeesPageStore } from 'store/pages/quote/add-employees/pageStore';
import { RouteV2Id } from 'routes/routesConfigV2';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import { QuoteTableManagementPanel } from './QuoteTableManagementPanel';
import { QuoteAddEmployeesTable } from './QuoteAddEmployeesTable';
import { ExpectedGroupSizeModal } from './ExpectedGroupSizeModal';
import { EditExpectedGroupSizeModal } from './EditExpectedGroupSizeModal';
import { ExpectedGroupSizeInfoBlock } from './ExpectedGroupSizeInfoBlock';

// TESTING_POLICY: CYPRESS_ONLY

export const PageContent: React.FC = observer(() => {
  const pageStore = useQuoteAddEmployeesPageStore();
  const {
    onComplete,
    stepCanComplete,
    expectedGroupSizeModalStore,
    editExpectedGroupSizeModalStore,
    showExpectedGroupSize,
    expectedGroupSize,
  } = pageStore;

  useEffect(() => {
    void pageStore.getInitialData();
  }, []);

  const showGroupSizeInfo = showExpectedGroupSize && !!expectedGroupSize;

  return (
    <QuoteFlowLayout
      flowDelegate={pageStore.flowDelegate}
      pageId={RouteV2Id.QUOTE_ADD_EMPLOYEES}
      pageHeader={{
        subtitleMaxWidth: '42rem',
        ...(showGroupSizeInfo ? { spacing: HEADER_SPACING_PRESETS.withTopSectionAndActionBelow } : {}),
      }}
      isPageLoading={pageStore.flowDelegate.isInitialDataLoading}
      pageFooter={{
        onComplete,
        disableCompleteButton: !stepCanComplete,
      }}
    >
      {showGroupSizeInfo ? (
        <ExpectedGroupSizeInfoBlock
          groupSize={expectedGroupSize}
          onEdit={(): void => editExpectedGroupSizeModalStore.open()}
        />
      ) : null}
      <QuoteTableManagementPanel />
      <QuoteAddEmployeesTable />
      <ExpectedGroupSizeModal modalStore={expectedGroupSizeModalStore} />
      <EditExpectedGroupSizeModal modalStore={editExpectedGroupSizeModalStore} />
    </QuoteFlowLayout>
  );
});
